import { Label, Select, SelectContent, SelectItem, SelectTrigger, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { languages, useLanguage } from '@/hooks/useLanguage';
import { useUserContext } from '@/lib/auth';

export const SelectLanguage = () => {
  const { t } = useTranslation();
  const { changeLanguage: changeAppLanguage, currentLanguage: currentAppLanguage } = useLanguage();
  const { changeLanguage: changeUserLanguage } = useUserContext();

  const changeLanguage = (lang: string) => {
    changeUserLanguage(lang);
    changeAppLanguage(lang);
  };

  return (
    <Stack spacing={2} className='max-w-xs py-2' data-testid='select-language'>
      <Label className='typography-body2'>{t('shared.account.labels.language')}</Label>
      <Select value={currentAppLanguage.code} onValueChange={changeLanguage}>
        <SelectTrigger>{currentAppLanguage.nativeTranslation}</SelectTrigger>
        <SelectContent>
          {Object.entries(languages).map(([key, label]) => (
            <SelectItem key={key} value={key}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Stack>
  );
};
